import React from "react";
import Testimonials from "../home/Testimonials";

const DataEnrichTestimonials = () => {
  return <Testimonials />;
};

export default DataEnrichTestimonials;
